import React, { ReactElement, useEffect } from 'react';
import { useDataCollection } from '../../../../hooks';
import CheckCard from '../../../components/Form/CheckCard';
import { InjectedWizardStepProps } from '../../../components/Steps/WizardStep';
import StepHeader from '../../../components/Layout/StepHeader';
import { roofInsulationOptions } from '../../../../data/enumerations';
import { WizardStep } from '../../../../types';
import { Form } from 'formik';

const StepRoofInsulation = ({ completeStep, setNextStepId }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, values } = useDataCollection();

    useEffect(() => {
        if (values.roofInsulation) {
            const nextStepId = values.roofInsulation === 'NONE' ? WizardStep.Final : WizardStep.RoofInsulationThickness;
            setNextStepId && setNextStepId(nextStepId);
            completeStep && completeStep(true);
        }
    }, [values, completeStep]);

    return (
        <Form>
            <StepHeader title="Zateplení střechy" />
            <div className={'wiz-card wiz-card--small'}>
                <div className={'wiz-card__inner'}>
                    {roofInsulationOptions.map(({ value, title, description, img }) => {
                        return (
                            <div key={value} className={'wiz-card-item'}>
                                <CheckCard
                                    name={'roofInsulation'}
                                    onChange={handleChange}
                                    checked={values.roofInsulation === value}
                                    value={value}
                                    img={img}
                                    bigImg={true}
                                    title={title}
                                    description={description}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </Form>
    );
};

export default StepRoofInsulation;
